import { t } from "@lingui/macro";
import { Banner } from "@src/components/ui-kit";
import { useRouter } from "next/router";

interface NotInternallyApprovedProps {
  projectId: string;
}

export const NotInternallyApproved = (props: NotInternallyApprovedProps) => {
  const router = useRouter();

  return (
    <Banner
      size="sm"
      px="3"
      py="2"
      status="error"
      title={t`Assigned budget is not internally approved`}
      description={t`Please send it to the responsible person.`}
      primaryAction={{
        title: t`View budget`,
        onClick: () =>
          router.push({
            pathname: "/projects/budgets",
            query: { id: props.projectId },
          }),
      }}
    />
  );
};
